// TODO:区分コード管理.xlsx参考

import commonUtil from "../../ts/util/commonUtil"

/*
 * Q0001	公開範囲区分
 */
export const e公開範囲区分 = {
  全社: "1",
  部所: "2",
  自分のみ: "3",
} as const

export type T公開範囲区分名称 = keyof typeof e公開範囲区分
export type T公開範囲区分 = typeof e公開範囲区分[T公開範囲区分名称]

/*
 * Q0002	フィルタ種別区分
 */
export const eフィルタ種別区分 = {
  WhereCondition: "1",
  OpenBrackets: "2",
  CloseBrackets: "3",
  JoinOperator: "4",
} as const

export type Tフィルタ種別区分名称 = keyof typeof eフィルタ種別区分
export type Tフィルタ種別区分 = typeof eフィルタ種別区分[Tフィルタ種別区分名称]

/*
 * Q0003	比較演算子区分
 */
export const e比較演算子区分 = {
  Between: "1",
  LessThan: "2",
  LessThanEqual: "3",
  GreaterThan: "4",
  GreaterThanEqual: "5",
  Equal: "6",
  NotEqual: "7",
  Like: "8",
  NotLike: "9",
  IN: "10",
  NotIn: "11",
  IsNull: "12",
  IsNotNull: "13",
  RegexMatch: "14",
} as const

export type T比較演算子区分名称 = keyof typeof e比較演算子区分
export type T比較演算子区分 = typeof e比較演算子区分[T比較演算子区分名称]

/*
 * Q0004	接続条件区分
 */
export const e接続条件区分 = {
  AND: "1",
  OR: "2",
} as const

export type T接続条件区分名称 = keyof typeof e接続条件区分
export type T接続条件区分 = typeof e接続条件区分[T接続条件区分名称]

/*
 * Q0005	並替条件区分
 */
export const e並替条件区分 = {
  ASC: "1",
  DESC: "2",
} as const

export type T並替条件区分名称 = keyof typeof e並替条件区分
export type T並替条件区分 = typeof e並替条件区分[T並替条件区分名称]

/*
 * Q0006	フィールド型区分
 */
export const eフィールド型区分 = {
  String: "1",
  Number: "2",
  Date: "3",
  Datetime: "4",
} as const

export const getフィールド型区分PropertyNameByKey =
  commonUtil.getReverseEnum(eフィールド型区分)

export type Tフィールド型区分名称 = keyof typeof eフィールド型区分
export type Tフィールド型区分 = typeof eフィールド型区分[Tフィールド型区分名称]
